import React from 'react';
import './Footer.css';

const Footer = () => {
    return (
        <footer className="footer">
            <div className="container">
                <div className="footer-left">
                    
                </div>
                <div className="footer-right">
                    <p className="copyright">&copy;2025 – All Right Reserved</p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;